import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxIconButtonComponent } from './phx-icon-button.component';
import { PhxIconModule } from '../icon/icon.module';

@NgModule({
  declarations: [PhxIconButtonComponent],
  imports: [CommonModule, PhxIconModule],
  exports: [PhxIconButtonComponent],
})
export class PhxIconButtonModule {}
